(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lion-google-reviews"] && !Shopify.designMode) return;
  try {
    
  const initializeLionGoogleReviews = (root = document) => {
    root.querySelectorAll('[data-lion-google-reviews]').forEach((section) => {
      if (section.dataset.initialized === 'true') return;

      const reviewsToggle = section.querySelector('[data-reviews-toggle]');

      const refreshTextToggles = () => {
        section.querySelectorAll('.lion-google-review-card').forEach((card) => {
          if (card.offsetParent === null) return;

          const text = card.querySelector('[data-review-text]');
          const toggle = card.querySelector('[data-review-text-toggle]');
          if (!text || !toggle || text.classList.contains('is-expanded')) return;

          toggle.hidden = text.scrollHeight <= text.clientHeight + 1;
        });
      };

      section.querySelectorAll('[data-review-text-toggle]').forEach((toggle) => {
        toggle.addEventListener('click', () => {
          const text = toggle.previousElementSibling;
          const expanded = toggle.getAttribute('aria-expanded') === 'true';

          text.classList.toggle('is-expanded', !expanded);
          toggle.setAttribute('aria-expanded', String(!expanded));
          toggle.textContent = expanded ? toggle.dataset.moreLabel : toggle.dataset.lessLabel;
        });
      });

      reviewsToggle?.addEventListener('click', () => {
        const expanded = reviewsToggle.getAttribute('aria-expanded') === 'true';

        section.classList.toggle('is-expanded', !expanded);
        reviewsToggle.setAttribute('aria-expanded', String(!expanded));
        reviewsToggle.textContent = expanded
          ? reviewsToggle.dataset.moreLabel
          : reviewsToggle.dataset.lessLabel;

        requestAnimationFrame(refreshTextToggles);
      });

      window.addEventListener('resize', refreshTextToggles, { passive: true });
      section.dataset.initialized = 'true';
      requestAnimationFrame(refreshTextToggles);
    });
  };

  initializeLionGoogleReviews();
  document.addEventListener('shopify:section:load', (event) => initializeLionGoogleReviews(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const stickyHeader = document.querySelector('sticky-header');
    if(stickyHeader) {
      stickyHeader.setupWindowResizeEvent();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
